import Icons from 'assets/icons'
import AccordionComp from 'components/accordion/Accordion'
import AvatarList from 'components/avatarList/AvatarList'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import TableHeader from 'components/tableHeader/TableHeader'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { Calendar } from 'primereact/calendar'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog'
import IyzicoBill from './IyzicoBill'
import Rate from './Rate'
import Team from './Team'
import { approvalModalLoading, closeInlineApprovalModal, closeSidebar } from 'redux/features/general/generalSlice'
import Tooltip from 'components/tooltip/Tooltip'

import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	setBillsData,
	setDevelopmentsData,
	setSlaData,
	setMemoData,
	setProjectData,
	updateProjectData,
	setInvoiceStatues,
	deleteBillsRow,
	deleteDevelopmentsRow,
	deleteSlaRow,
	deleteMemoRow,
	setCrStatuses,
	setOngoingStatuses,
	setOngoingData,
	updateOngoingData,
	setTechnologies,
	setEdittedRow,
	setOutsourceData,
	setOutsourceInvoiceData,
	deleteOutsourceRow,
	deleteOutsourceInvoiceRow,
	setLeasingData,
	deleteLeasingRow
} from 'redux/features/projectDetail/projectDetailSlice'
import useEditor from 'hooks/useEditor'
import moment from 'moment'
import FileUploadEditor from 'components/fileUploadEdıtor/FıleUploadEdıtor'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useRequest } from 'hooks/useRequest'
import {
	currencyTypes,
	getAlertClass,
	getResponsible,
	isAdmin,
	isAM,
	isPM,
	outsourcePeriod,
	projectTypes,
	reportTypes,
	responsibleRoles,
	roleIds,
	slaTypes,
	sourceTypes,
} from 'utils/Constants'
import useToast from 'hooks/useToast'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import { openApprovalModal, closeApprovalModal } from 'redux/features/general/generalSlice'
import SlaModalContent from 'components/modalContent/SlaModalContent'
import AddCrModalContent from 'components/modalContent/AddCrModalContent'
import AddMemoModalContent from 'components/modalContent/AddMemoModalContent'
import SlaInvoicesModalContent from 'components/modalContent/SlaInvoicesModalContent'
import Spinner from 'components/loader/Spinner'
import CrInvoicesModalContent from 'components/modalContent/CrInvoicesModalContent'
import { currencyFormatter } from 'utils/CurrencyFormatter'
import { InputNumber } from 'primereact/inputnumber'
import { Dropdown } from 'primereact/dropdown'
import AddDocumentModalContent from 'components/modalContent/AddDocumentModalContent'
import InvoiceInlineApprovalModalContent from 'components/modalContent/InvoiceInlineApprovalModal'
import { getPermission, userInfo } from 'utils/Auth'
import ApprovalModalContent from 'components/modalContent/ApprovalModalContent'
import EditInvoiceModalContent from 'components/modalContent/EditInvoiceModalContent'
import AddOutsourceModalContent from 'components/modalContent/AddOutsourceModalContent'
import AddOutsourceInvoiceModalContent from 'components/modalContent/AddOutsourceInvoiceModalContent'
import AddLeasingModalContent from 'components/modalContent/AddLeasingModalContent'
import LeasingInvoicesModalContent from 'components/modalContent/LeasingInvoicesModalContent'

const ProjectDetail = () => {
	const { projectId } = useParams()
	const navigate = useNavigate()
	const [getProjectDetail, projectDetailLoading] = useRequest()
	const [saveProjectDetail] = useRequest()
	const [getBillsData] = useRequest()
	const [getInvoicesStatus] = useRequest()
	const [updateInvoiceRow] = useRequest()
	const [getFile] = useRequest()
	const [getCrData] = useRequest()
	const [getOngoingData] = useRequest()
	const [getTechnologies] = useRequest()
	const [saveOngoingData] = useRequest()
	const [updateCRInvoiceRow] = useRequest()
	const [getSlaData] = useRequest()
	const [getMemoData] = useRequest()
	const [deleteTableRow] = useRequest()
	const [syncJira] = useRequest()
	const [outsourceRequest] = useRequest()
	const { showToast } = useToast()
	const [dialog, setDialog] = useState(false)
	const [teamDialog, setTeamDialog] = useState(false)
	const [iyzicoDialog, setIyzicoDialog] = useState(false)
	const [isNewOngoing, setIsNewOngoing] = useState(false)
	const [addSlaModal, setAddSlaModal] = useState(false)
	const [slaInvoicesModal, setSlaInvoicesModal] = useState({ open: false, isClosed: false, slaId: null, step: 1, header: 'SLA Faturaları', width: '70%' })
	const [crInvoicesModal, setCrInvoicesModal] = useState({ open: false, isClosed: false, crId: null, step: 1, header: 'Ek Geliştirme Faturaları' })
	const [addCrModal, setAddCrModal] = useState(false)
	const [editInvoiceModal, setEditInvoiceModal] = useState({ open: false, formData: {}, isEditable: false })
	const [addMemoModal, setAddMemoModal] = useState({ open: false, edit: false, data: {} })
	const [documentModal, setDocumentModal] = useState(false)
	const [addOutsourceModal, setAddOutsourceModal] = useState({ open: false, id: null })
	const [addOutsourceInvoiceModal, setAddOutsourceInvoiceModal] = useState({ open: false, id: null })
	const [upsertLeasingModal, setUpsertLeasingModal] = useState({ open: false, id: null })
	const [leasingInvoicesModal, setLeasingInvoicesModal] = useState({ open: false, isClosed: false, leasingId: null, step: 1, header: 'Kiralama Faturaları', width: '70%' })
	const [widthRate, setRateWidth] = useState('80vw')
	const [widthTeam, setTeamWidth] = useState('80vw')
	const { textAreaEditor, textEditor, calendarEditor, selectEditor, rowEditorBody, currencyEditor, percentEditor, InvoiceSelectEditor, calendarShortDateEditor, numberEditor, multiSelectEditor, calendarStartEndEditor } = useEditor()
	const { projectDetail, general } = useSelector((state) => state)
	const { approvalModal, invoiceInlineApprovalModal } = general
	const { billsData, developmentsData, slaData, memoData, project, ongoingData, ongoingStatuses, invoiceStatuses, crStatuses, technologies, edittedRow, outsourceData, outsourceInvoiceData, leasingData } = projectDetail
	const dispatch = useDispatch()
	const [accountManager, setAccountManager] = useState([])
	const [projectManager, setProjectManager] = useState([])
	const [currentRate, setCurrentRate] = useState([])
	const [projectDocument, setProjectDocument] = useState([])
	const [approval, setApproval] = useState({ open: false })
	const [isAddReview, setIsAddReview] = useState()
	const [isAddDocument, setIsAddDocument] = useState()
	const [isAddCr, setIsAddCr] = useState()
	const [isAddSla, setIsAddSla] = useState()
	const [isAddTurnkey, setIsAddTurnkey] = useState()
	const [isUpdateTurnkey, setIsUpdateTurnkey] = useState()
	const [isListSla, setIsListSla] = useState()
	const [isUpdateSla, setIsUpdateSla] = useState()
	const [isListCr, setIsListCr] = useState()
	const [isDeleteCr, setIsDeleteCr] = useState()
	const [isDeleteSla, setIsDeleteSla] = useState()
	const [isDeleteTurnkey, setIsDeleteTurnkey] = useState()
	const [isUpdateCr, setIsUpdateCr] = useState()
	const [isAddOutsource, setIsAddOutsource] = useState()
	const [isDeleteOutsource, setIsDeleteOutsource] = useState()
	const [isUpdateOutsource, setIsUpdateOutsource] = useState()
	const [isAddInvoice, setIsAddInvoice] = useState()
	const [isUpdateInvoice, setIsUpdateInvoice] = useState()
	const [isDeleteInvoice, setIsDeleteInvoice] = useState()
	const [isDeleteLeasing, setIsDeleteLeasing] = useState()
	const [isUpdateLeasing, setIsUpdateLeasing] = useState()
	// const [switchToggles, setSwitchToggles] = useState([{checked:project?.scheduledJiraIntegration,label:'Evet', value:true},{checked:!project?.scheduledJiraIntegration,label:'Hayır',value:false}])
	const [request] = useRequest()
	const [developers, setDevelopers] = useState([])
	const [crmCompanies, setCrmCompanies] = useState([])



	const setRateFunc = (value) => {
		value && setRateWidth(value)
	}
	const setTeamFunc = (value) => {
		value && setTeamWidth(value)
	}
	const checkBetween = (date1, date2, date3) => {
		return moment(date1).isBetween(date2, date3);
	}
	const fetchProjectDetail = () => {
		dispatch(closeSidebar())
		handleOngoingOpen()
		handleSlaOpen()
		handleCrOpen()
		handleMemoOpen()
		handleOutsourceAllOpen()
		handleLeasingOpen()
		getProjectDetail('/Project/GetProjectById', {
			method: 'GET',
			params: { id: projectId },
		}).then((res) => {
			if (res.data.ok) {
				const filteredRoles = res.data.result?.projectRoles?.filter(r => !r.endDate || (r.endDate && moment(new Date(), 'YYYY-MM-DD').diff(moment(r.endDate).format('YYYY-MM-DD'), 'days') < 1))
				setAccountManager(filteredRoles?.filter((r) => r.roleId == roleIds.accountManager))
				setProjectManager(filteredRoles?.filter((r) => r.roleId == roleIds.projectManager))
				setCurrentRate(res.data.result?.rates?.find(d => checkBetween(moment(new Date(), 'YYYY-MM-DD'), moment(d.periodStart).format('YYYY-MM-DD'), moment(d.periodEnd).format('YYYY-MM-DD'))));
				setProjectDocument(res.data.result?.projectDocuments);
				dispatch(
					setProjectData({
						...res.data.result,
						types: [...res.data.result.types.map(t => ({ label: t.type.toUpperCase(), value: t.type }))],
						continuousReportTypes: [...res.data.result.continuousReportTypes.map(t => {
							if (t?.continuousReportType?.toUpperCase() == 'YOK') {
								return null
							} else {
								return { label: t?.continuousReportType?.toUpperCase() == "HAFTALIKSTATU" ? "HAFTALIK STATÜ RAPORU" : "AYLIK SLA RAPORU", value: t.continuousReportType == "HAFTALIKSTATU" ? 1 : 2 }
							}
						})],
						projectRoles: [...filteredRoles],
						projectTechnologies: [...res.data.result.projectTechnologies.map((pt) => (

							{
								label: pt?.technology?.name, value: pt?.technology?.id
							}
						))]


					})
				)
			}
		})
		getInvoicesStatus('/InvoiceStatus/GetAllInvoiceStatuses', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				dispatch(
					setInvoiceStatues(
						res.data.result.map((d) => {
							return { value: d.id, label: d.name }
						})
					)
				)
			}
		})


		getTechnologies('/Technologies/GetAllTechnologies', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				const data = res.data.result
				dispatch(setTechnologies(data))
			}
		})
	}
	useEffect(() => {
		request('/CrmManagement/GetAllCrmForDirectoryCompanies', { method: 'GET' }).then((res) => {
			if (res.data?.ok) {
				setCrmCompanies(
					(res.data.result || []).map((c) => ({
						label: c.newCrmCompanyName || c.name || '',
						value: c.id,
					}))
				)
			}
		})
	}, [])
	useEffect(() => {
		fetchProjectDetail()
		if (userInfo) {
			setIsAddReview(userInfo['Memo.create']?.includes('True'))
			setIsAddDocument(userInfo['ProjectDocument.create']?.includes('True'))
			setIsAddCr(userInfo['Cr.create']?.includes('True'))
			setIsAddSla(userInfo['Sla.create']?.includes('True'))
			setIsAddTurnkey(userInfo['Ongoing.create']?.includes('True'))
			setIsUpdateTurnkey(userInfo['Ongoing.update']?.includes('True'))
			setIsListSla(userInfo['Sla.read']?.includes('True'))
			setIsListCr(userInfo['Cr.read']?.includes('True'))
			setIsUpdateCr(userInfo['Cr.update']?.includes('True'))
			setIsDeleteCr(userInfo['Cr.delete']?.includes('True'))
			setIsDeleteSla(userInfo['Sla.delete']?.includes('True'))
			setIsDeleteTurnkey(userInfo['Ongoing.delete']?.includes('True'))
			setIsUpdateSla(userInfo['Sla.update']?.includes('True'))
			setIsAddOutsource(userInfo['Outsource.create']?.includes('True'))
			setIsDeleteOutsource(userInfo['Outsource.delete']?.includes('True'))
			setIsUpdateOutsource(userInfo['Outsource.update']?.includes('True'))
			setIsAddInvoice(userInfo['Invoice.create']?.includes('True'))
			setIsUpdateInvoice(userInfo['Invoice.update']?.includes('True'))
			setIsDeleteInvoice(userInfo['Invoice.delete']?.includes('True'))
			setIsDeleteLeasing(userInfo['Leasing.delete']?.includes('True'))
			setIsUpdateLeasing(userInfo['Leasing.update']?.includes('True'))
		}




	}, [projectId])
	useEffect(() => {
		if (slaInvoicesModal.isClosed) {
			handleSlaOpen()
		}
		if (crInvoicesModal.isClosed) {
			handleCrOpen()
		}
		if (leasingInvoicesModal.isClosed) {
			handleLeasingOpen()
		}
	}, [slaInvoicesModal.isClosed, crInvoicesModal.isClosed, leasingInvoicesModal.isClosed])

	useEffect(() => {
		request('/Developer/GetAllDevelopers', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setDevelopers(
					res.data.result
					.sort((a, b) => a.fullName.localeCompare(b.fullName))
					.map((s) => ({
						label: s.fullName,
						value: s.id,
					}))
				)
			}
		})
	}, [])

	const saveProject = () => {
		saveProjectDetail('/Project/UpdateProjects', {
			method: 'PUT',
			data: {
				id: project.id, name: project.name, jiraKey: project?.jiraKey, doneDoneId: project?.doneDoneId, jiraId: project?.jiraId, projectDevelopers: project?.projectDevelopers, projectNote: project?.projectNote, crmManagementId: project.crmManagementId, isArchive: project.isArchive, continuousReportTypes: project?.continuousReportTypes?.map((t) => {
					if (t == null) {
						return { continuousReportType: 'YOK', projectId: project.id }
					} else {
						return { continuousReportType: t.value, projectId: project.id }
					}
				}), types: project.types?.map((t) => ({ type: t.value })), projectTechnologies: project.projectTechnologies.map((t) => ({ technologyId: t.value, projectId: project.id }))
			},
		}).then((res) => {
			if (res.data.ok) {
				showToast('Proje Kaydedildi', 'success')
			}
		})
	}
	const downloadFile = (fileInfo, downloadEndpoint) => {
		getFile(downloadEndpoint, {
			method: 'GET',
			params: { id: fileInfo.id },
		}).then(res => {
			const link = document.createElement('a');
			link.href = `data:${fileInfo.documentType};base64,${res.data.result}`
			link.setAttribute(
				'download',
				fileInfo.fileName,
			);
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
		})
	}
	const handleOngoingOpen = () => {
		getOngoingData('/Ongoing/GetOngoingProjectById', {
			method: 'GET',
			params: {
				id: projectId
			}
		}).then(res => {
			if (res.data.ok) {
				dispatch(setOngoingData(res.data.result))
				getBillsData('/Invoices/GetInvoiceProjectByAndSourceId', {
					method: 'GET',
					params: { projectid: projectId, sourceid: res.data.result.id },
				}).then((res) => {
					if (res.data.ok) {
						const data = res.data.result
						console.log(data, "12312");
						dispatch(setBillsData(data?.filter(dt => dt.sourceType == "Turnkey")))
					}
				})
			} else {
				setIsNewOngoing(true)
				dispatch(setBillsData([]))
				dispatch(setOngoingData(
					{
						"projectId": projectId,
						"signatureDate": null,
						"kickoffDate": null,
						"plannedComplete": null,
						"actualComplete": null,
						"statusId": null,
						"currency": 'TL',
						"liveDate": null,
						"budget": null,
						'monthlyManDay': null
					}
				))
			}
		})
		getInvoicesStatus('/OngoingStatus/GetAllOngoingStatuses', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				dispatch(
					setOngoingStatuses(
						res.data.result.map((d) => {
							return { value: d.id, label: d.name, name: 'statusId' }
						})
					)
				)
			}
		})
	}
	const handleSlaOpen = () => {
		getSlaData('/SLAs/GetSLAProjectById', {
			method: 'GET',
			params: { id: projectId }
		}).then(res => {
			if (res.data.ok) {
				dispatch(setSlaData(res.data.result?.sort((a, b) => {
					if (a.endDate == null) {
						return 1
					}
					if (b.endDate == null) {
						return -1
					}
					return moment(b.endDate).unix() < moment(a.endDate).unix() ? -1 : 1
				})))
			} else {
				dispatch(setSlaData([]))
			}
		})
	}
	const handleCrOpen = () => {
		getCrData('/ChangeRequests/GetChangeRequestsProjectById', {
			method: 'GET',
			params: { id: projectId }
		}).then(res => {
			if (res.data.ok) {
				dispatch(setDevelopmentsData(res.data.result))
			} else {
				dispatch(setDevelopmentsData([]))
			}
		})
		getInvoicesStatus('/CRStatuses/GetAllCRStatuses').then(res => {
			if (res.data.ok) {
				dispatch(
					setCrStatuses(
						res.data.result.map((d) => {
							return { value: d.id, label: d.name }
						})
					)
				)
			}
		})
	}

	const handleOutsourceAllOpen = () => {
		handleOutsourceOpen()
		handleOutsourceInvoicesOpen()
	}

	const handleOutsourceOpen = () => {
		outsourceRequest('/Outsource/GetAllOutsources', {
			method: 'GET',
			params: { projectId: projectId }
		}).then(res => {
			if (res.data.ok) {
				dispatch(setOutsourceData(res.data.result?.sort((a, b) => {
					if (a.endDate == null) {
						return 1
					}
					if (b.endDate == null) {
						return -1
					}
					return moment(b.endDate).unix() < moment(a.endDate).unix() ? -1 : 1
				})))
			} else {
				dispatch(setOutsourceData([]))
			}
		})
	}

	const handleOutsourceInvoicesOpen = () => {
		outsourceRequest('/Outsource/GetOutsourceInvoices', {
			method: 'GET',
			params: { projectId: projectId }
		}).then(res => {
			dispatch(setOutsourceInvoiceData(res.data.result || []))
		})
	}

	const handleLeasingOpen = () => {
		outsourceRequest('/Leasing/GetAllLeasings', {
			method: 'GET',
			params: { projectId: projectId }
		}).then(res => {
			if (res.data.ok) {
				dispatch(setLeasingData(res.data.result?.sort((a, b) => {
					if (a.endDate == null) {
						return 1
					}
					if (b.endDate == null) {
						return -1
					}
					return moment(b.endDate).unix() < moment(a.endDate).unix() ? -1 : 1
				})))
			} else {
				dispatch(setLeasingData([]))
			}
		})
	}

	const handleMemoOpen = (allShow) => {
		getMemoData('/Memo/GetMemosProjectById', {
			method: 'GET',
			params: { id: projectId, allShow: allShow }
		}).then(res => {

			if (res.data.ok) {
				dispatch(setMemoData(res.data.result))
			} else {
				dispatch(setMemoData([]))
			}
		})
	}

	const handleDocumentOpen = () => {
		getMemoData('/Project/GetProjectById', {
			method: 'GET',
			params: { id: projectId }
		}).then(res => {
			if (res.data.ok) {
				dispatch(setProjectDocument(res.data.result?.projectDocuments))


			} else {
				dispatch(setProjectData([]))
			}
		})
	}

	const handleOngoingChange = (e) => {
		dispatch(updateOngoingData({ name: e.name, value: e.value }))
	}
	const handleOngoingSubmit = () => {
		if (!ongoingData.statusId) {
			showToast('Lütfen Proje Durumu Seçin', 'error')
		}
		else if (isNewOngoing) {
			saveOngoingData('/Ongoing/AddOngoings', {
				method: 'POST',
				data: { ...ongoingData, projectId: projectId }
			}).then(res => {
				if (res.data.ok) {
					showToast('Ongoing Verileri Kaydedildi', 'success')
					getOngoingData('/Ongoing/GetOngoingProjectById', {
						method: 'GET',
						params: {
							id: projectId
						}
					}).then(res => {
						if (res.data.ok) {
							dispatch(setOngoingData(res.data.result))
							setIsNewOngoing(false)
						} else {
							setIsNewOngoing(true)
							dispatch(setBillsData([]))
							dispatch(setOngoingData(
								{
									"projectId": projectId,
									"signatureDate": null,
									"kickoffDate": null,
									"plannedComplete": null,
									"actualComplete": null,
									"statusId": null,
									"currency": null,
									"liveDate": null,
									"budget": null,
									'monthlyManDay': null
								}
							))
						}
					})
				}
			})
		} else {
			saveOngoingData('/Ongoing/UpdateOngoings', {
				method: 'PUT',
				data: ongoingData
			}).then(res => {
				if (res.data.ok) {
					showToast('Ongoing Verileri Kaydedildi', 'success')
				}
			})
		}
	}
	const onRowEditComplete1 = (e) => {
		let _products2 = [...billsData]
		let { index } = e
		_products2[index] = edittedRow
		updateInvoiceRow('/Invoices/UpdateInvoices', {
			method: 'PUT',
			data: { ...edittedRow, amount: edittedRow?.amount?.toString(), sourceType: sourceTypes.TURNKEY },
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setBillsData(_products2))
				showToast('Güncelleme Başarılı', 'success')
			}
			dispatch(setEdittedRow({}))
		})
	}
	const onRowEditCompleteSla = (e) => {
		let _products2 = [...slaData]
		let { index } = e
		_products2[index] = edittedRow
		updateCRInvoiceRow('/SLAs/UpdateSLAs', {
			method: 'PUT',
			data: edittedRow,
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setSlaData(_products2))
				showToast('Güncelleme Başarılı', 'success')
			}
			dispatch(setEdittedRow({}))
		})
	}
	const onRowEditCompleteCR = (e) => {
		let _products2 = [...developmentsData]
		let { index } = e
		_products2[index] = edittedRow
		updateCRInvoiceRow('/ChangeRequests/UpdateChangeRequests', {
			method: 'PUT',
			data: edittedRow,
		}).then((res) => {
			if (res.data.ok) {
				getCrData('/ChangeRequests/GetChangeRequestsProjectById', {
					method: 'GET',
					params: { id: projectId }
				}).then(res => {
					if (res.data.ok) {
						dispatch(setDevelopmentsData(res.data.result))
					} else {
						dispatch(setDevelopmentsData([]))
					}
				})
				dispatch(setEdittedRow({}))
				showToast('Güncelleme Başarılı', 'success')
			}
			dispatch(setEdittedRow({}))
		})
	}
	const onRowEditCompleteMemo = (e) => {
		let _products2 = [...memoData]
		let { index } = e
		_products2[index] = edittedRow
		updateCRInvoiceRow('/Memo/UpdateMemos', {
			method: 'PUT',
			data: edittedRow,
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setMemoData(_products2))
				showToast('Güncelleme Başarılı', 'success')
			}
			dispatch(setEdittedRow({}))
		})
	}
	const onRowEditCompleteOutsourceInvoice = (e) => {
		let _products2 = [...billsData]
		let { index } = e
		_products2[index] = edittedRow
		updateInvoiceRow('/Invoices/UpdateInvoices', {
			method: 'PUT',
			data: { ...edittedRow, amount: edittedRow?.amount?.toString() },
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setOutsourceInvoiceData(_products2))
				showToast('Güncelleme Başarılı', 'success')
			}
			dispatch(setEdittedRow({}))
		})
	}
	const handleCloseInlineApprovalModal = () => {
		dispatch(closeInlineApprovalModal())
	}

	const handleDeleteRow = (deleteData, deleteEndpoint, tableForDelete) => {
		dispatch(openApprovalModal({ open: true, content: 'Silmek istedğinize emin misiniz?', deleteData, deleteEndpoint, tableForDelete }))
	}
	const handleSubmitApproved = () => {
		console.log(project,'project')
		saveProjectDetail('/Project/UpdateProjects', {
			method: 'PUT',
			data: { id: project.id, name: project.name, crmManagementId: project.crmManagementId, isArchive: !project.isArchive, continuousReportTypes: project.continuousReportTypes.filter(t => t != null).map((t) => ({ continuousReportType: t.value, projectId: project.id })), types: project.types.map((t) => ({ type: t.value })), projectTechnologies: project.projectTechnologies.map((t) => ({ technologyId: t.value, projectId: project.id })) },
		}).then((res) => {
			if (res.data.ok) {
				dispatch(updateProjectData({ name: 'isArchive', value: !project.isArchive }))
				showToast('Proje Kaydedildi', 'success')
				handleCloseApproval()
			}
		})
	}
	const handleCloseApproval = () => {
		setApproval({ open: false })
	}
	const handleCloseApprovalModal = async () => {
		dispatch(closeApprovalModal())
	}

	const handleSubmitApproval = async () => {
		if (approvalModal.tableForDelete == 'invoices') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: { ...approvalModal.deleteData, amount: approvalModal?.deleteData?.amount?.toString() },
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteBillsRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'changeRequests') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: approvalModal.deleteData,
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteDevelopmentsRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'slas') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: approvalModal.deleteData,
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteSlaRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'memos') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: approvalModal.deleteData,
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteMemoRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'cb') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: { ...approvalModal.deleteData, amount: approvalModal?.deleteData?.amount?.toString() },
			}).then(async (res) => {
				if (res.data.ok) {
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'project') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: approvalModal.deleteData,
			}).then(async (res) => {
				if (res.data.ok) {
					await handleCloseApprovalModal()
					showToast('Proje silindi', 'success')
					navigate('/projects')
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		} if (approvalModal.tableForDelete == 'projectDocuments') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: approvalModal.deleteData,
			}).then(async (res) => {
				if (res.data.ok) {
					setProjectDocument((prev) => ([...prev.filter(i => i.id != approvalModal.deleteData.id)]))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'outsources') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: { ...approvalModal.deleteData },
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteOutsourceRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'outsourceInvoices') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: { ...approvalModal.deleteData, amount: approvalModal?.deleteData?.amount?.toString() },
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteOutsourceInvoiceRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
		if (approvalModal.tableForDelete == 'leasings') {
			await dispatch(approvalModalLoading())
			deleteTableRow(approvalModal.deleteEndpoint, {
				method: 'DELETE',
				data: { ...approvalModal.deleteData },
			}).then(async (res) => {
				if (res.data.ok) {
					dispatch(deleteLeasingRow(approvalModal.deleteData.id))
					await handleCloseApprovalModal()
				} else {
					showToast('Silme İşleminde bir hata oluştu', 'error')
				}
			})
		}
	}
	const deleteButton = (deleteData, deleteEndpoint, tableForDelete) => {
		return (
			<Icons.deleteNotFill
				onClick={() => {
					handleDeleteRow(deleteData, deleteEndpoint, tableForDelete)
				}}
				size={20}
				className='text-danger cursor-pointer'
			/>
		)
	}
	const doneDonetoJiraSync = () => {
		if (!project.doneDoneId || !project.jiraId) {
			showToast('DoneDone Project ID ve Jira Project ID alanlarının girilmesi gereklidir', 'error')
		} else {
			syncJira('/Project/DoneDone2Jira', {
				method: 'POST',
				data: { projectId: projectId },
			}).then(res => {
				if (res?.data?.ok) {
					// setSwitchToggles([...switchToggles.map(tg => {
					// 	return {...tg,checked:!tg.checked}
					// })])
					showToast('DoneDone > Jira başarılı', 'success')

				} else {
					showToast(res?.data?.metadata?.message, 'error')
					// setSwitchToggles([...switchToggles.map(tg => {
					// 	return {...tg,checked:tg.checked}
					// })])
				}
			})

		}
	}
	if (!project) {
		return null
	}
	const totalDoneDone = project?.totalIssues
	const isAttentionInvoice = () => {
		const sum = billsData.length > 0 && billsData.map((e) => Number(e.amount)).reduce((partialSum, a) => partialSum + a, 0)
		return sum != ongoingData.budget && billsData.length != 0 ? true : false
	}
	const invoiceStatusTextReturner = (invoice) => {
		const statuName = invoice.status.name
		if (statuName.toLowerCase().includes('kesildi') || statuName.toLowerCase().includes('ödendi')) {
			return { text: statuName, class: 'alert-success cursor-pointer' }
		} else if (statuName.toLowerCase().includes('kesilebilir')) {
			const expectedDate = invoice.estimatedDate && moment(invoice.estimatedDate)
			const diff =
				invoice.estimatedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'month')
			return {
				text: `Fatura Kesilebilir - ${moment(invoice.estimatedDate).format('lll')}`,
				class: diff > 0 ? 'alert-danger text-bold cursor-pointer' : 'alert-info cursor-pointer',
			}
		} else if (statuName.toLowerCase().includes('müşteri onayı')) {
			return { text: 'Müşteri Onayı', class: 'alert-warning cursor-pointer' }
		} else {
			return { text: statuName, class: 'alert-warning cursor-pointer' }
		}
	}
	return (
		<AnimatedSpan className='page-container d-flex flex-column gap-4'>
			{!projectDetailLoading && (
				<div style={{position: 'relative', width: '100%', top: '-16px', marginBottom: '50px'}}>
					<div className="card" style={{position: 'fixed', width: '100%', zIndex: 1, left: 0, borderRadius: 0}}>
						<div className="d-flex justify-content-between gap-3">
							<div className="row flex-1">
								<div className="col-md-6">
									<h1 className='heading-1 text-bold'>
									{project?.crmManagementDisplayName ? `${project.crmManagementDisplayName} - ` : ''}
									{project?.name}
									{project?.serviceProvider != null && ` - ${project.serviceProvider === 1 ? 'Odito' : 'Nuevo'}`}
								</h1>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<div className='card'>
				{
					projectDetailLoading ? <div className='row text-center'>
						<div className='col-md-12'>
							<Spinner size={3} />
						</div>
					</div>
						: <>
							<div className='row-margin-x'>
								<div className="col-md-4">
								</div>
								<div className="col-md-8 d-flex justify-content-end align-items-center flex-wrap gap-3">
									{
										project?.doneDoneId && <div className='form-control-label d-flex justify-content-between align-items-center'>{totalDoneDone ? `${totalDoneDone} Adet Aktif DoneDone Kaydı Vardır ` : 'Aktif DoneDone kaydı bulunmamaktadır '} &nbsp; <Tooltip text={project?.doneDoneDetails?.map(done => (`${done.key} : ${done.value}`))?.join('\n')} containerClass={'d-flex'} textClass={'icon-text'}>
											<Icons.info />
										</Tooltip>
										</div>
									}
									{!isPM && <Button className='btn-success' title='Rate Yönetimi' handleClick={setDialog} />}
									<Button className='btn-success' title='Ekip Yönetimi' handleClick={setTeamDialog} />
									<Link target='_blank' to={`/project-report/${project.id}`} className='btn-success' >
										Proje Raporu
									</Link>
									{
										project?.projectRoles?.length > 0 && <AvatarList handleClickLastItem={setTeamDialog} images={project?.projectRoles?.slice(0, 4)} lastItemContent={project?.projectRoles?.length > 4 ? `${project?.projectRoles?.slice(4).length}+` : null} />
									}
								</div>
							</div>
							<hr className='divider my-md-3' />
							<div className='row'>
								<div className='col-md-10 col-lg-11 col-xl-11'>
									<div className="row-margin-x">
										<div className="col-md-8">
											<div className="row-margin-x">
												<div className="col-md-6">
													<div className='form-control'>
														<label className='form-control-label'>Müşteri / Şirket</label>
														<DefaultSelect
															placeholder={project?.crmManagementId == null && project?.customerName ? project.customerName : 'Müşteri / Şirket seçin'}
															isSearchable
															isClearable
															selectOptions={crmCompanies}
															value={project?.crmManagementId != null ? crmCompanies.find((c) => c.value === project.crmManagementId) : null}
															handleChange={(e) => dispatch(updateProjectData({ name: 'crmManagementId', value: e?.value ?? null }))}
														/>
													</div>
												</div>
												<div className='col-md-6'>
													<div className='form-control'>
														<label className='form-control-label'>Proje Adı</label>
														<input
															className='default-input'
															type='text'
															name='name'
															onChange={(e) => dispatch(updateProjectData({ name: e.target.name, value: e.target.value }))}
															value={project.name}
														/>
													</div>
												</div>
											</div>
											<div className='row-margin-x mt-3'>
												<div className='col-md-6'>
													<div className='form-control'>
														<div className='form-control-label'>Teknolojiler</div>
														<DefaultSelect
															isMulti
															value={project?.projectTechnologies}
															selectOptions={technologies?.map((pt) => ({ label: pt.name, value: pt.id }))}
															handleChange={(e) => dispatch(updateProjectData({ name: 'projectTechnologies', value: e }))}
														/>
													</div>
												</div>
												<div className='col-md-6'>
													<div className='form-control'>
														<div className='form-control-label'>Proje Tipi</div>
														<DefaultSelect
															isMulti
															value={project.types}
															selectOptions={projectTypes.map((pt) => ({ label: pt.type.toUpperCase(), value: pt.type }))}
															handleChange={(e) => dispatch(updateProjectData({ name: 'types', value: e }))}
														/>
													</div>
												</div>
											</div>
											<div className='row-margin-x mt-3'>
												<div className='col-md-6'>
													<div className='form-control'>
														<label className='form-control-label'>Account Manager</label>
														<input
															className='default-input'
															type='text'
															name='accountManager'
															disabled
															value={accountManager && accountManager?.map((d) => `${d.user.firstName} ${d.user.lastName}`).join(', ')}
														/>
													</div>
												</div>
												<div className='col-md-6'>
													<div className='form-control'>
														<div className='form-control-label'>Proje Sorumlusu/Yöneticisi</div>
														<input
															className='default-input'
															type='text'
															name='projectManager'
															disabled
															value={projectManager && projectManager?.map((d) => `${d.user.firstName} ${d.user.lastName}`).join(', ')}
														/>
													</div>
												</div>
											</div>
											<div className="row-margin-x mt-3">
												<div className="col-md-12">
													<div className="form-control">
														<label className='form-control-label'>Geliştiriciler</label>
														<DefaultSelect
															isClearable
															isSearchable
															isMulti
															value={project?.projectDevelopers?.map((t) => developers.find((d) => d.value === t.developerId))}
															handleChange={(e) =>
																dispatch(
																	updateProjectData({
																		name: 'projectDevelopers',
																		value:
																			e?.map((t) => ({
																				id: project?.projectDevelopers?.find((mt) => mt.developerId === t.value)?.id,
																				developerId: t.value,
																			})) || [],
																	})
																)
															}
															name='projectDevelopers'
															selectOptions={developers}
														/>
													</div>
												</div>
											</div>
											<div className="row-margin-x mt-3">
												<div className="col-md-6">
													<div className='form-control'>
														<div className='form-control-label'>Döküman Tipi</div>
														<DefaultSelect
															isMulti
															value={project?.continuousReportTypes}
															selectOptions={reportTypes.map((pt) => ({ label: pt?.type?.toUpperCase(), value: Number(pt.value) }))}
															handleChange={(e) => dispatch(updateProjectData({ name: 'continuousReportTypes', value: e }))}
														/>
													</div>
												</div>
												<div className="col-md-6">
													<div className='form-control'>
														<label className='form-control-label'>Güncel Rate</label>
														<input
															className='default-input'
															type='text'
															name='projectManager'
															disabled
															value={currentRate && `${currencyFormatter(currentRate?.budget)} ${currentRate?.currency} / ${moment(currentRate?.periodEnd).format('LL')}`}
														/>
													</div>
												</div>
											</div>
										</div>
										<div className='col-md-4 d-flex flex-column'>
											<div className="row-margin-x">
												<div className={`col-md-6`}>
													<div className='form-control'>
														<label className='form-control-label'>Jira Key</label>
														<input
															className='default-input'
															type='text'
															name='jiraKey'
															onChange={(e) => dispatch(updateProjectData({ name: e.target.name, value: e.target.value }))}
															value={project?.jiraKey && project?.jiraKey}
														/>
													</div>
												</div>
												<div className="col-md-6">
													<div className='form-control'>
														<label className='form-control-label d-flex justify-content-between align-items-center'>Jira Id</label>
														<input
															className='default-input'
															type='text'
															name='jiraId'
															onChange={(e) => dispatch(updateProjectData({ name: e.target.name, value: e.target.value }))}
															value={project?.jiraId && project?.jiraId}
														/>
													</div>
												</div>
											</div>
											<div className="row-margin-x mt-3">
												{/* <div className="col-md-6">
													<ToggleSwitch disabled={!project.doneDoneId || !project.jiraId} onChange={(e) => doneDonetoJiraSync(e)} toggleLabel={'DoneDone to Jira Sync'} toggleName='scheduledJiraIntegration' toggles={switchToggles} />
												</div> */}
												<div className="col-md-12">
													<div className='form-control'>
														<div className='form-control-label'>DoneDone Id</div>
														<input
															className='default-input'
															type='text'
															name='doneDoneId'
															onChange={(e) => dispatch(updateProjectData({ name: e.target.name, value: e.target.value }))}
															value={project?.doneDoneId && project?.doneDoneId}
														/>
													</div>
												</div>
											</div>


											<div className='form-control mt-3 flex-1'>
												<label className='form-control-label'>Not</label>
												<textarea
													className='default-input h-100'
													type='text'
													name='projectNote'
													onChange={(e) => dispatch(updateProjectData({ name: e.target.name, value: e.target.value }))}
													value={project?.projectNote}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className='col-md-2 col-lg-1 col-xl-1 d-flex px-md-0 flex-column align-items-end'>
									<Button title='Kaydet' handleClick={saveProject} className='btn-success w-100 d-flex justify-content-center mt-4' />
									{!isAM && !isPM && <Button title='Projeyi Sil' handleClick={() => handleDeleteRow(projectDetail.project, '/Project/DeleteProjects', 'project')} className='btn-danger w-100 d-flex justify-content-center mt-3' />}
									{!isAM && !isPM && <Button title={project.isArchive ? 'Arşivden Çıkar' : 'Arşivle'} handleClick={() => { setApproval({ open: true, content: project.isArchive ? 'Proje Arşivden Çıkarılacak Onaylıyor Musunuz?' : 'Proje Arşive Eklenecek Onaylıyor Musunuz?' }) }} className='btn-primary w-100 d-flex justify-content-center mt-3' />}
									<Button title='DoneDone > Jira' handleClick={doneDonetoJiraSync} className='btn-success w-100 d-flex justify-content-center mt-4' />
								</div>
							</div>
						</>
				}
			</div>

			{
				project?.types?.length > 0 && project.types.map((t, i) => {

					if (t.value == 'Turnkey' && ongoingData?.status?.id == 5) {
						return <div key={i} className='row-margin-x mt-3'>
							<div className='col-md-12'>
								<AccordionComp onVal={true} title='Turnkey Proje Bilgileri' onTabOpen={handleOngoingOpen} >
									<div>
										<div className='row'>
											<div className='col-md-10 col-lg-11 col-xl-11'>
												<div className='row-margin-x'>
													<div className='col-md-4'>
														<div className='form-control'>
															<div className='form-control-label'>Proje Durumu</div>
															<Dropdown
																optionLabel='label'
																placeholder='Proje Durumu'
																name='statusId'
																value={ongoingData.statusId}
																options={ongoingStatuses}
																onChange={(e) => handleOngoingChange(e.target)}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Kickoff Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Kickoff Tarihi'
																value={ongoingData.kickoffDate && new Date(ongoingData.kickoffDate)}
																name='kickoffDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Alfa Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Alfa Tarihi'
																value={ongoingData.alphaDate && new Date(ongoingData.alphaDate)}
																name='alphaDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
												</div>
												<div className='row-margin-x mt-3'>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Beta Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Beta Tarihi'
																value={ongoingData.betaDate && new Date(ongoingData.betaDate)}
																name='betaDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Canlı Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Canlı Tarihi'
																value={ongoingData.liveDate && new Date(ongoingData.liveDate)}
																name='liveDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Proje Süresi - Adam/Gün</label>
															<input type='text' className="default-input" name='monthlyManDay' value={ongoingData?.monthlyManDay} onChange={(e) => handleOngoingChange({ value: e.target.value, name: 'monthlyManDay' })} />
														</div>
													</div>
												</div>
												<div className='row-margin-x mt-3'>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Garanti Süresi</label>
															<input type='text' className="default-input" name='garantiDate' value={ongoingData?.garantiDate} onChange={(e) => handleOngoingChange({ value: e.target.value, name: 'garantiDate' })} />
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Bütçe</label>
															<InputNumber mode="decimal" minFractionDigits={2} maxFractionDigits={2} placeholder='Bütçe' value={ongoingData.budget} name='budget' onChange={(e) => handleOngoingChange({ name: 'budget', value: e.value })} />
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<div className='form-control-label'>Para Birimi</div>
															<Dropdown
																optionLabel='label'
																optionValue='value'
																placeholder='Para Birimi'
																name='currency'
																value={ongoingData.currency}
																options={currencyTypes}
																onChange={(e) => {
																	handleOngoingChange(e.target)
																}}
															/>
														</div>
													</div>
												</div>
											</div>
											<div className='col-md-2 col-lg-1 col-xl-1 px-0 d-flex justify-content-end'>
												<span className='w-100'>
													{isUpdateTurnkey && <Button title='Kaydet' handleClick={handleOngoingSubmit} className='btn-success w-100 d-flex justify-content-center mt-4' />}
												</span>
											</div>
										</div>
										<div className='row-margin-x mt-5'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı'
													size="small"
													responsiveLayout="stack"
													editMode='row'
													dataKey='id'
													onRowEditInit={e => dispatch(setEdittedRow(e.data))}
													header={
														<TableHeader
															title='Faturalar'
															isAttention={isAttentionInvoice()}
															button={isAddTurnkey && <Button className='btn-primary btn-sm px-2'
																title='Yeni Fatura Adımı Ekle' icon={<Icons.plus />}
																handleClick={setIyzicoDialog} />}
														/>
													}
													onRowEditComplete={onRowEditComplete1}
													value={billsData}
												>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='name'
														style={{ width: 'auto' }}
														header='Proje Adımı'
														sortable='true'
														editor={(options) => textEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='responsibleRole'
														header='Sorumlu Kişi'
														style={{ maxWidth: '8rem' }}
														sortable='true'
														body={(rowData) => {
															return <span>{getResponsible(rowData.responsibleRole)}</span>
														}}
														editor={(options) =>
															selectEditor(
																{ ...options },
																responsibleRoles
															)
														}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='percent'
														header='Ödeme Yüzdesi'
														style={{ width: '6rem' }}
														sortable='true'
														body={(rowData) => <span>%{rowData.percent}</span>}
														editor={(options) => percentEditor(options, ongoingData.budget)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='estimatedDate'
														header='Kesilecek Ay'
														style={{ width: '8rem' }}
														sortable='true'
														body={(rowData) => {
															const expectedDate = rowData.estimatedDate && moment(rowData.estimatedDate)
															const diff = rowData.estimatedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'month')
															return (
																<span className={diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) ? 'text-danger' : ''}>
																	{' '}
																	<span>{expectedDate && expectedDate.format('ll')}</span> <span>{diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) && 'Süresi Geçti'}</span>
																</span>
															)
														}}
														editor={(options) => calendarShortDateEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='invoiceDate'
														style={{ width: '8rem' }}
														header='Fatura Tarihi'
														sortable='true'
														body={(rowData) => {
															const actualDate = rowData.invoiceDate && moment(rowData.invoiceDate).format('LL')
															return <span>{actualDate}</span>
														}}
														editor={(options) => calendarEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='amount'
														style={{ width: '12rem' }}
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.amount)} {rowData.currency}
																</span>
															)
														}}
														header='Tutar'
														sortable='true'
														editor={(options) => currencyEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														field='invoicesDocuments'
														header='Ödeme Onayı'
														headerClassName='text-bold bg-primary text-default'
														sortable='true'
														style={{ width: 'auto' }}
														editor={(options) => (
															<FileUploadEditor
																addEndpoint='/Invoices/AddInvoiceDocuments'
																deleteEndpoint='/Invoices/DeleteInvoiceDocuments'
																idName='InvoiceId'
																options={options}
															/>
														)}
														body={(rowData) => (
															<ul className='list-style-none word-break'>
																{rowData.invoicesDocuments &&
																	rowData.invoicesDocuments.map((p, i) => (
																		<li key={i}>
																			<a
																				download={p.fileName}
																				href={`data:${p.documentType};base64,${p.data}`}
																				className='text-primary text-underlined cursor-pointer mr-2'
																			>
																				{p?.fileName}
																			</a>
																		</li>
																	))}
															</ul>
														)}
													/>
													<Column
														className='text-semi-bold text-sm'
														field='invoiceStatusId'
														header='Durum'
														headerClassName='text-bold bg-primary text-default'
														sortable='true'
														style={{ maxWidth: '8rem' }}
														body={(rowData) => {
															return <span className={getAlertClass(rowData?.invoiceStatusId)}>{invoiceStatuses?.find(s => s.value == rowData.invoiceStatusId)?.label}</span>
														}}
														editor={(options) => InvoiceSelectEditor({ ...options }, invoiceStatuses.filter(s => (!s.label?.toLowerCase().includes('ödendi') && !s.label?.toLowerCase().includes('kesildi'))))}
													/>
													{isAddTurnkey && <Column headerClassName='text-bold bg-primary text-default' style={{ width: '2.5rem' }} rowEditor body={(row, d) => rowEditorBody(d)} />}
													<Column
														field='action'
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold pl-0'
														style={{ width: '2.5rem' }}
														body={(rowData) => <span className='d-flex'>{isDeleteTurnkey && deleteButton(rowData, '/Invoices/DeleteInvoices', 'invoices')}</span>}
													/>
												</DataTable>
											</div>
										</div>
									</div>
								</AccordionComp>
							</div>
						</div>
					} else if (t.value == 'Turnkey') {
						return <div key={i} className='row-margin-x mt-3'>
							<div className='col-md-12'>
								<AccordionComp title='Turnkey Proje Bilgileri' onTabOpen={handleOngoingOpen} >
									<div>
										<div className='row'>
											<div className='col-md-10 col-lg-11 col-xl-11'>
												<div className='row-margin-x'>
													<div className='col-md-4'>
														<div className='form-control'>
															<div className='form-control-label'>Proje Durumu</div>
															<Dropdown
																optionLabel='label'
																placeholder='Proje Durumu'
																name='statusId'
																value={ongoingData.statusId}
																options={ongoingStatuses}
																onChange={(e) => handleOngoingChange(e.target)}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Kickoff Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Kickoff Tarihi'
																value={ongoingData.kickoffDate && new Date(ongoingData.kickoffDate)}
																name='kickoffDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Alfa Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Alfa Tarihi'
																value={ongoingData.alphaDate && new Date(ongoingData.alphaDate)}
																name='alphaDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
												</div>
												<div className='row-margin-x mt-3'>

													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Beta Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Beta Tarihi'
																value={ongoingData.betaDate && new Date(ongoingData.betaDate)}
																name='betaDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Canlı Tarihi</label>
															<Calendar
																dateFormat='dd/mm/yy'
																placeholder='Canlı Tarihi'
																value={ongoingData.liveDate && new Date(ongoingData.liveDate)}
																name='liveDate'
																onChange={(e) => {
																	handleOngoingChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
																}}
															/>
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Proje Süresi - Adam/Gün</label>
															<input type='text' className="default-input" name='monthlyManDay' value={ongoingData?.monthlyManDay} onChange={(e) => handleOngoingChange({ value: e.target.value, name: 'monthlyManDay' })} />
														</div>
													</div>
												</div>
												<div className='row-margin-x mt-3'>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Garanti Süresi</label>
															<input type='text' className="default-input" name='garantiDate' value={ongoingData?.garantiDate} onChange={(e) => handleOngoingChange({ value: e.target.value, name: 'garantiDate' })} />
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<label className='form-control-label'>Bütçe</label>
															<InputNumber mode="decimal" minFractionDigits={2} maxFractionDigits={2} placeholder='Bütçe' value={ongoingData.budget} name='budget' onChange={(e) => handleOngoingChange({ name: 'budget', value: e.value })} />
														</div>
													</div>
													<div className='col-md-4'>
														<div className='form-control'>
															<div className='form-control-label'>Para Birimi</div>
															<Dropdown
																optionLabel='label'
																optionValue='value'
																placeholder='Para Birimi'
																name='currency'
																value={ongoingData.currency}
																options={currencyTypes}
																onChange={(e) => {
																	handleOngoingChange(e.target)
																}}
															/>
														</div>
													</div>
												</div>
											</div>
											<div className='col-md-2 col-lg-1 col-xl-1 px-0 d-flex justify-content-end'>
												<span className='w-100'>
													{isUpdateTurnkey && <Button title='Kaydet' handleClick={handleOngoingSubmit} className='btn-success w-100 d-flex justify-content-center mt-4' />}
												</span>
											</div>
										</div>
										<div className='row-margin-x mt-5'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı'
													size="small"
													responsiveLayout="stack"
													editMode='row'
													dataKey='id'
													onRowEditInit={e => dispatch(setEdittedRow(e.data))}
													header={
														<TableHeader
															title='Faturalar'
															isAttention={isAttentionInvoice()}
															button={isAddTurnkey && <Button className='btn-primary btn-sm px-2'
																title='Yeni Fatura Adımı Ekle' icon={<Icons.plus />}
																handleClick={setIyzicoDialog} />}
														/>
													}
													onRowEditComplete={onRowEditComplete1}
													value={billsData}
												>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='name'
														style={{ width: 'auto' }}
														header='Proje Adımı'
														sortable='true'
														editor={(options) => textEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='responsibleRole'
														header='Sorumlu Kişi'
														style={{ maxWidth: '8rem' }}
														sortable='true'
														body={(rowData) => {
															return <span>{getResponsible(rowData.responsibleRole)}</span>
														}}
														editor={(options) =>
															selectEditor(
																{ ...options, disabled: !isAdmin },
																responsibleRoles
															)
														}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='percent'
														header='Ödeme Yüzdesi'
														style={{ width: '6rem' }}
														sortable='true'
														body={(rowData) => <span>%{rowData.percent}</span>}
														editor={(options) => percentEditor(options, ongoingData.budget)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='estimatedDate'
														header='Kesilecek Ay'
														style={{ width: '8rem' }}
														sortable='true'
														body={(rowData) => {
															const expectedDate = rowData.estimatedDate && moment(rowData.estimatedDate)
															const diff = rowData.estimatedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'month')
															return (
																<span className={diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) ? 'text-danger' : ''}>
																	{' '}
																	<span>{expectedDate && expectedDate.format('ll')}</span> <span>{diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) && 'Süresi Geçti'}</span>
																</span>
															)
														}}
														editor={(options) => calendarShortDateEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='invoiceDate'
														style={{ width: '8rem' }}
														header='Fatura Tarihi'
														sortable='true'
														body={(rowData) => {
															const actualDate = rowData.invoiceDate && moment(rowData.invoiceDate).format('LL')
															return <span>{actualDate}</span>
														}}
														editor={(options) => calendarEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='amount'
														style={{ width: '12rem' }}
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.amount)} {rowData.currency}
																</span>
															)
														}}
														header='Tutar'
														sortable='true'
														editor={(options) => currencyEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														field='invoicesDocuments'
														header='Ödeme Onayı'
														headerClassName='text-bold bg-primary text-default'
														sortable='true'
														style={{ width: 'auto' }}
														editor={(options) => (
															<FileUploadEditor
																addEndpoint='/Invoices/AddInvoiceDocuments'
																deleteEndpoint='/Invoices/DeleteInvoiceDocuments'
																idName='InvoiceId'
																options={options}
															/>
														)}
														body={(rowData) => (
															<ul className='list-style-none word-break'>
																{rowData.invoicesDocuments &&
																	rowData.invoicesDocuments.map((p, i) => (
																		<li key={i}>
																			<a
																				download={p.fileName}
																				href={`data:${p.documentType};base64,${p.data}`}
																				className='text-primary text-underlined cursor-pointer mr-2'
																			>
																				{p?.fileName}
																			</a>
																		</li>
																	))}
															</ul>
														)}
													/>
													<Column
														className='text-semi-bold text-sm'
														field='invoiceStatusId'
														header='Durum'
														headerClassName='text-bold bg-primary text-default'
														sortable='true'
														style={{ maxWidth: '8rem' }}
														body={(rowData) => {
															return <span className={getAlertClass(rowData?.invoiceStatusId)}>{invoiceStatuses?.find(s => s.value == rowData.invoiceStatusId)?.label}</span>
														}}
														editor={(options) => InvoiceSelectEditor({ ...options }, invoiceStatuses.filter(s => (!s.label?.toLowerCase().includes('ödendi') && !s.label?.toLowerCase().includes('kesildi'))))}
													/>
													{isAddTurnkey && <Column headerClassName='text-bold bg-primary text-default' style={{ width: '2.5rem' }} rowEditor body={(row, d) => rowEditorBody(d)} />}
													<Column
														field='action'
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold pl-0'
														style={{ width: '2.5rem' }}
														body={(rowData) => <span className='d-flex'>{isDeleteTurnkey && deleteButton(rowData, '/Invoices/DeleteInvoices', 'invoices')}</span>}
													/>
												</DataTable>
											</div>
										</div>
									</div>
								</AccordionComp>
							</div>
						</div>
					}

					else if (t.value == 'Cr') {
						return <div key={i} className='row-margin-x  mt-3'>
							<div className='col-md-12'>
								<AccordionComp title='Ek Geliştirmeler' onTabOpen={handleCrOpen}>
									<div>
										<div className='row-margin-x'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı.'
													responsiveLayout="stack"
													editMode='row'
													dataKey='id'
													style={{ width: 'auto' }}
													onRowEditInit={e => dispatch(setEdittedRow(e.data))}
													header={
														<TableHeader
															title='Onaylanan Ek Geliştirmeler'
															button={isAddCr && <Button className='btn-primary btn-sm px-2' title='Ek Geliştirme Ekle' handleClick={() => setAddCrModal(true)} icon={<Icons.plus />} />}
														/>
													}
													onRowEditComplete={onRowEditCompleteCR}
													value={developmentsData}
												>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='name'
														style={{ width: 'auto' }}
														header='Ek Geliştirme Adı'
														sortable='true'
														editor={(options) => textEditor(options)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='startDate'
														style={{ width: '15rem' }}
														header='Başlangıç-Bitiş Tarihi'
														sortable='true'
														body={(rowData) => {
															const actualEndDate = rowData.endDate ? moment(rowData.endDate).format('LL') : 'Devam Ediyor'
															const actualStartDate = rowData.startDate && moment(rowData.startDate).format('LL')
															return <span>{actualStartDate} - {actualEndDate}</span>
														}}
														editor={(options) => calendarStartEndEditor(options, 'startDate', 'endDate')}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='monthlyManDay'
														header='M/D'
														style={{ width: '6rem' }}
														sortable='true'
														editor={(options) => numberEditor(options, currentRate?.budget)}
														body={(rowData) => {
															return (
																rowData?.monthlyManDay && <span>
																	{rowData.monthlyManDay} {`(${Number(rowData.monthlyManDay) * 8} saat)`}
																</span>
															)
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='budget'
														header='Bütçe'
														sortable='true'
														style={{ width: 'auto' }}
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.budget)} {rowData.currency}
																</span>
															)
														}}
														editor={(options) => currencyEditor(options)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='changeRequestsDocuments'
														style={{ width: '14rem' }}
														header='CR Talebi Dokümanları'
														sortable='false'
														editor={(options) => (
															<FileUploadEditor
																addEndpoint='/ChangeRequests/AddChangeRequestsDocuments'
																deleteEndpoint='/ChangeRequests/DeleteChangeRequestsDocuments'
																idName='ChangeRequestId'
																options={options}
															/>
														)}
														body={(rowData) => (
															<ul className='list-style-none word-break'>
																{rowData.changeRequestsDocuments &&
																	rowData.changeRequestsDocuments.map((p, i) => (
																		<li key={i}>
																			<a
																				download={p.fileName}
																				href={`data:${p.documentType};base64,${p.data}`}
																				className='text-primary text-underlined cursor-pointer mr-2'
																			>
																				{p?.fileName}
																			</a>
																		</li>
																	))}
															</ul>
														)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='statusId'
														header='Geliştirme Durumu'
														style={{ width: 'auto' }}
														sortable='true'
														editor={(options) =>
															selectEditor(options, crStatuses)
														}
														body={(rowData) => (
															<span className={rowData.statusId == 2 ? 'alert-warning' : 'alert-success'}>{crStatuses?.find(s => s.value == rowData.statusId)?.label}</span>
														)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='invoices'
														header='Fatura Durumu'
														style={{ width: 'auto' }}
														sortable='true'
														editor={() => {
															const invoices = edittedRow.invoices
															return <div className='d-flex flex-column gap-2'>
																{
																	invoices?.length > 0 && invoices.map((invoice, index) => {
																		const status = invoiceStatusTextReturner(invoice)
																		return <div key={invoice.id}>
																			{invoices.length != 1 && <div>{index + 1}. Fatura</div>}
																			<div onClick={() => setEditInvoiceModal({ open: true, formData: { ...invoice }, isEditable: false })} className={status.class} >{status.text}</div>
																		</div>
																	})
																}
															</div>
														}
														}
														body={(rowData) => (
															<div className='d-flex flex-column gap-2'>
																{
																	rowData?.invoices?.length > 0 && rowData.invoices.map((invoice, index) => {
																		const status = invoiceStatusTextReturner(invoice)
																		return <div key={invoice.id}>
																			{rowData?.invoices?.length != 1 && <div>{index + 1}. Fatura</div>}
																			<div onClick={() => setEditInvoiceModal({ open: true, formData: { ...invoice }, isEditable: false })} className={status.class} >{status.text}</div>
																		</div>
																	})
																}
															</div>
														)}
													/>

													{isUpdateCr && <Column headerClassName='text-bold bg-primary text-default' rowEditor body={(row, d) => rowEditorBody(d)}
														className='text-semi-bold text-center' style={{ width: '2.5rem' }} />}
													<Column
														headerClassName='text-bold bg-primary text-default'
														field='action'
														className='text-semi-bold pl-0'
														style={{ width: '4rem' }}
														body={(rowData) => (
															<span className='d-flex gap-1'>
																{isListCr && <Icons.invoice
																	size={18}
																	onClick={() => {
																		setCrInvoicesModal({ open: true, step: 1, budget: rowData?.budget, currency: rowData?.currency, crId: rowData.id, header: `${rowData.name} Faturaları` })
																	}}
																	className='text-success cursor-pointer'
																/>}
																{isDeleteCr && deleteButton(rowData, '/ChangeRequests/DeleteChangeRequests', 'changeRequests')}
															</span>
														)}
													/>
												</DataTable>
											</div>
										</div>
									</div>
								</AccordionComp>
							</div>
						</div>
					} else if (t.value == 'Sla') {
						return <div key={i} className='row-margin-x  mt-3'>
							<div className='col-md-12'>
								<AccordionComp title='SLA Dönemi' onTabOpen={handleSlaOpen}>
									<div>
										<div className='row-margin-x'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı'
													size="small"
													responsiveLayout="stack"
													editMode='row'
													dataKey='id'
													onRowEditInit={e => dispatch(setEdittedRow(e.data))}
													header={
														<TableHeader title='SLA Dönemleri' button={isAddSla && <Button className='btn-primary btn-sm' title='SLA Dönemi Ekle' handleClick={() => setAddSlaModal(true)} icon={<Icons.plus />} />} />
													}
													value={slaData}
													onRowEditComplete={onRowEditCompleteSla}
												>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='startDate'
														header='Dönem Başlangıç Tarihi'
														sortable='true'
														style={{ width: '8rem' }}
														body={(rowData) => {
															const actualDate = rowData.startDate && moment(rowData.startDate).format('LL')
															return <span>{actualDate}</span>
														}}
														editor={(options) => calendarEditor(options)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='endDate'
														style={{ width: '8rem' }}
														header='Dönem Bitiş Tarihi'
														sortable='true'
														body={(rowData) => {
															const actualDate = rowData.endDate && moment(rowData.endDate).format('LL')
															return <span>{actualDate}</span>
														}}
														editor={(options) => calendarEditor(options)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='slaDocuments'
														style={{ width: '8rem' }}
														header='İmzalı Sözleşme'
														sortable='true'
														editor={(options) => (
															<FileUploadEditor
																addEndpoint='/SLAs/AddSlaDocuments'
																deleteEndpoint='/SLAs/DeleteSlaDocuments'
																idName='SlaId'
																options={options}
															/>
														)}
														body={(rowData) => (
															<ul className='list-style-none word-break'>
																{rowData.slaDocuments &&
																	rowData.slaDocuments.map((p, i) => (
																		<li key={i}>
																			<a
																				download={p.fileName}
																				href={`data:${p.documentType};base64,${p.data}`}
																				className='text-primary text-underlined cursor-pointer mr-2'
																			>
																				{p?.fileName}
																			</a>
																		</li>
																	))}
															</ul>
														)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='type'
														header='Tipi'
														style={{ width: '7rem' }}
														sortable='true'
														editor={(options) =>
															multiSelectEditor(options, slaTypes)
														}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='monthlyManDay'
														header='M/D'
														style={{ width: '6rem' }}
														sortable='true'
														editor={(options) => numberEditor(options)}
														body={(rowData) => <span>{rowData.monthlyManDay != null ? rowData.monthlyManDay : '-'}</span>}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='budget'
														header='Bütçe'
														style={{ width: '9rem' }}
														sortable='true'
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.budget)} {rowData.currency}
																</span>
															)
														}}
														editor={(options) => currencyEditor(options)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='invoiceStatuses'
														header='Fatura Durumu'
														sortable='true'
														style={{ width: '10rem' }}
													/>
													{isUpdateSla && <Column headerClassName='text-bold bg-primary text-default' style={{ width: '2.5rem' }} rowEditor body={(row, d) => rowEditorBody(d)} />}
													<Column
														field='action'
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold pl-0'
														style={{ width: '2.5rem' }}
														body={(rowData) => (
															<span className='d-flex gap-1'>
																{
																	isListSla && <Icons.invoice
																		size={20}
																		onClick={() => {
																			setSlaInvoicesModal({ open: true, step: 1, budget: rowData?.budget, currency: rowData?.currency, slaId: rowData.id, header: `${moment(rowData.startDate).format('LL')} - ${moment(rowData.endDate).format('LL')} Dönemi Faturaları` })
																		}}
																		className='text-success cursor-pointer'
																	/>
																}
																{isDeleteSla && deleteButton(rowData, '/SLAs/DeleteSLAs', 'slas')}
															</span>
														)}
													/>
												</DataTable>
											</div>
										</div>
									</div>
								</AccordionComp>
							</div>
						</div>
					} else if (t.value == 'Outsource') {
						return <div key={i} className='row-margin-x  mt-3'>
							<div className='col-md-12'>
								<AccordionComp title='Outsource' onTabOpen={handleOutsourceAllOpen}>
									<div>
										<div className='row-margin-x'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı'
													responsiveLayout="stack"
													dataKey='id'
													header={
														<TableHeader title='Personeller' button={isAddOutsource && <Button className='btn-primary btn-sm' title='Personel Ekle' handleClick={() => setAddOutsourceModal({open: true, id: null})} icon={<Icons.plus />} />} />
													}
													value={outsourceData}
													rowClassName={'cursor-pointer table-hover'}
													onRowClick={e => {
														if (e.originalEvent.target.className.includes('p-button-icon')) return
														if (isUpdateOutsource && e.data.id) {
															setAddOutsourceModal({ open: true, id: e.data.id })
														}
													}}
												>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='name'
														style={{ width: 'auto' }}
														header='Personel Adı'
														sortable='true'
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='position'
														style={{ width: 'auto' }}
														header='Pozisyon'
														sortable='true'
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='startDate'
														header='Başlangıç Tarihi'
														sortable='true'
														style={{ width: '15rem' }}
														body={(rowData) => {
															const actualDate = rowData.startDate && moment(rowData.startDate).format('LL')
															return <span>{actualDate}</span>
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='endDate'
														style={{ width: '15rem' }}
														header='Bitiş Tarihi'
														sortable='true'
														body={(rowData) => {
															const actualDate = rowData.endDate ? moment(rowData.endDate).format('LL') : 'Devam Ediyor'
															return <span>{actualDate}</span>
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='period'
														header='Periyot'
														style={{ width: '9rem' }}
														sortable='true'
														body={(rowData) => {
															const text = outsourcePeriod.find(p => p.value === rowData.period)?.type
															return <span>{text}</span>
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='rate'
														header='Güncel Rate'
														style={{ width: '9rem' }}
														sortable='true'
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.rate)} {rowData.rateCurrency}
																</span>
															)
														}}
													/>
													<Column
														field='action'
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold pl-0'
														style={{ width: '2.5rem' }}
														body={(rowData) => (
															<span className='d-flex gap-1'>
																{isDeleteOutsource && deleteButton(rowData, '/Outsource/DeleteOutsource', 'outsources')}
															</span>
														)}
													/>
												</DataTable>
											</div>
										</div>
										<div className='row-margin-x mt-5'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı'
													responsiveLayout="stack"
													editMode='row'
													dataKey='id'
													onRowEditInit={e => dispatch(setEdittedRow(e.data))}
													header={
														<TableHeader title='Faturalar' button={isAddInvoice && <Button className='btn-primary btn-sm px-2' title='Fatura Ekle' handleClick={() => setAddOutsourceInvoiceModal({open: true, id: null})} icon={<Icons.plus />} />} />
													}
													onRowEditComplete={onRowEditCompleteOutsourceInvoice}
													value={outsourceInvoiceData}
												>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='name'
														style={{ width: 'auto' }}
														header='Adım'
														sortable='true'
														editor={(options) => textEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='responsibleRole'
														header='Sorumlu Kişi'
														style={{ width: '13rem' }}
														sortable='true'
														body={(rowData) => {
															return <span>{getResponsible(rowData.responsibleRole)}</span>
														}}
														editor={(options) =>
															selectEditor(
																{ ...options },
																responsibleRoles
															)
														}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='estimatedDate'
														header='Kesilecek Ay'
														style={{ width: '9rem' }}
														sortable='true'
														body={(rowData) => {
															const expectedDate = rowData.estimatedDate && moment(rowData.estimatedDate)
															const diff = rowData.estimatedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'month')
															return (
																<span className={diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) ? 'text-danger' : ''}>
																	{' '}
																	<span>{expectedDate && expectedDate.format('ll')}</span> <span>{diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) && 'Süresi Geçti'}</span>
																</span>
															)
														}}
														editor={(options) => calendarShortDateEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='invoiceDate'
														style={{ width: '10rem' }}
														header='Fatura Tarihi'
														sortable='true'
														body={(rowData) => {
															const actualDate = rowData.invoiceDate && moment(rowData.invoiceDate).format('LL')
															return <span>{actualDate}</span>
														}}
														editor={(options) => calendarEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														field='amount'
														style={{ width: '15rem' }}
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.amount)} {rowData.currency}
																</span>
															)
														}}
														header='Fatura Tutarı'
														sortable='true'
														editor={(options) => currencyEditor(options)}
													/>
													<Column
														className='text-semi-bold text-sm'
														headerClassName='text-bold bg-primary text-default'
														style={{ width: '8rem' }}
														header='Personeller'
														body={(rowData) => {
															return <a onClick={() => setAddOutsourceInvoiceModal({open: true, id: rowData.id})} className='text-primary text-underlined cursor-pointer'>Göster</a>
														}}
													/>
													<Column
														className='text-semi-bold text-sm'
														field='invoiceStatusId'
														header='Durum'
														headerClassName='text-bold bg-primary text-default'
														sortable='true'
														style={{ maxWidth: '8rem' }}
														body={(rowData) => {
															return <span className={getAlertClass(rowData?.invoiceStatusId)}>{invoiceStatuses?.find(s => s.value == rowData.invoiceStatusId)?.label}</span>
														}}
														editor={(options) => InvoiceSelectEditor({ ...options }, invoiceStatuses.filter(s => (!s.label?.toLowerCase().includes('ödendi') && !s.label?.toLowerCase().includes('kesildi'))))}
													/>
													{isUpdateInvoice && <Column headerClassName='text-bold bg-primary text-default' style={{ width: '2.5rem' }} rowEditor body={(row, d) => rowEditorBody(d)} />}
													<Column
														field='action'
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold pl-0'
														style={{ width: '2.5rem' }}
														body={(rowData) => <span className='d-flex'>{isDeleteInvoice && deleteButton(rowData, '/Invoices/DeleteInvoices', 'invoices')}</span>}
													/>
												</DataTable>
											</div>
										</div>
									</div>
								</AccordionComp>
							</div>
						</div>
					} else if (t.value == 'Leasing') {
						return <div key={i} className='row-margin-x  mt-3'>
							<div className='col-md-12'>
								<AccordionComp title='Kiralama' onTabOpen={handleLeasingOpen}>
									<div>
										<div className='row-margin-x'>
											<div className='col-md-12'>
												<DataTable
													emptyMessage='Hiç Kayıt Bulunamadı'
													responsiveLayout="stack"
													dataKey='id'
													header={
														<TableHeader title='Kiralamalar' button={isAddOutsource && <Button className='btn-primary btn-sm' title='Kiralama Ekle' handleClick={() => setUpsertLeasingModal({open: true, id: null})} icon={<Icons.plus />} />} />
													}
													value={leasingData}
													rowClassName={'cursor-pointer table-hover'}
													onRowClick={e => {
														if (e.originalEvent.target.className.includes('p-button-icon')) return
														if (isUpdateLeasing && e.data.id) {
															setUpsertLeasingModal({ open: true, id: e.data.id })
														}
													}}
												>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='startDate'
														header='Dönem Başlangıç'
														sortable='true'
														style={{ width: '15rem' }}
														body={(rowData) => {
															const actualDate = rowData.startDate && moment(rowData.startDate).format('LL')
															return <span>{actualDate}</span>
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='endDate'
														style={{ width: '15rem' }}
														header='Dönem Bitiş'
														sortable='true'
														body={(rowData) => {
															const actualDate = rowData.endDate && moment(rowData.endDate).format('LL')
															return <span>{actualDate}</span>
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='documents'
														style={{ width: '8rem' }}
														header='İmzalı Sözleşme'
														sortable='true'
														body={(rowData) => (
															<ul className='list-style-none word-break'>
																{rowData.documents &&
																	rowData.documents.map((p, i) => (
																		<li key={i}>
																			<a
																				download={p.fileName}
																				href={`data:${p.contentType};base64,${p.data}`}
																				className='text-primary text-underlined cursor-pointer mr-2'
																			>
																				{p?.fileName}
																			</a>
																		</li>
																	))}
															</ul>
														)}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='licenseNote'
														header='Lisans Notu'
														style={{ width: '16rem' }}
														sortable='true'
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='budget'
														header='Bütçe'
														style={{ width: '9rem' }}
														sortable='true'
														body={(rowData) => {
															return (
																<span>
																	{currencyFormatter(rowData.budget)} {rowData.currency}
																</span>
															)
														}}
													/>
													<Column
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold text-sm'
														field='invoiceStatuses'
														header='Fatura Durumu'
														sortable='true'
														style={{ width: '10rem' }}
													/>
													<Column
														field='action'
														headerClassName='text-bold bg-primary text-default'
														className='text-semi-bold pl-0'
														style={{ width: '2.5rem' }}
														body={(rowData) => (
															<span className='d-flex gap-1'>
																<Icons.invoice
																	size={20}
																	onClick={() => {
																		setLeasingInvoicesModal({ open: true, step: 1, currency: rowData?.currency, leasingId: rowData.id, header: `${moment(rowData.startDate).format('MMMM yy')} - ${moment(rowData.endDate).format('MMMM yy')} Dönemi Faturaları` })
																	}}
																	className='text-success cursor-pointer'
																/>
																{isDeleteLeasing && deleteButton(rowData, '/Leasing/DeleteLeasing', 'leasings')}
															</span>
														)}
													/>
												</DataTable>
											</div>
										</div>
									</div>
								</AccordionComp>
							</div>
						</div>
					} else {
						return null
					}
				})
			}
			<div className='row-margin-x mt-3'>
				<div className='col-md-12'>
					<AccordionComp title='Proje Notları' onTabOpen={handleMemoOpen}>
						<div>
							<div className='row-margin-x'>
								<div className='col-md-12'>
									<DataTable
										emptyMessage='Hiç Kayıt Bulunamadı'
										size="small"
										responsiveLayout="stack"
										editMode='row'
										onRowEditInit={e => dispatch(setEdittedRow(e.data))}
										dataKey='id'
										header={
											<TableHeader
												title='Review Kayıtları'
												button={(isAddReview || isPM) &&

													<div style={{ display: "flex" }}>

														<Button style={{ marginRight: "1rem" }} className='btn-primary btn-sm' handleClick={() => handleMemoOpen(true)} title='Tüm Kayıtları Göster' icon={<Icons.plus />} />
														<Button className='btn-primary btn-sm' handleClick={() => setAddMemoModal({ open: true, edit: false, data: {} })} title='Review Kaydı Ekle' icon={<Icons.plus />} /></div>}
											/>
										}
										onRowEditComplete={onRowEditCompleteMemo}
										value={memoData}
									>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold vertical-align-top'
											field='reviewDate'
											header='Review Tarihi'
											sortable='true'
											style={{ width: 'auto' }}
											body={(rowData) => {
												const actualDate = rowData.reviewDate && moment(rowData.reviewDate).format('LL')
												return <span>{actualDate}</span>
											}}
											editor={(options) => calendarEditor(options)}
										/>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold'
											style={{ width: 'auto', verticalAlign: 'baseline' }}
											field='createdBy'
											header='Oluşturan Kişi'
											sortable='true'
										/>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold'
											style={{ width: '40%' }}
											editor={(options) => textAreaEditor(options)}
											field='note'
											header='Not'
											sortable='true'
											body={(rowData) => <span className='dangeriousInnerHtml' dangerouslySetInnerHTML={{ __html: rowData?.note }} />}
										/>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold '
											field='memoDocuments'
											header='Ek Dosya'
											sortable='true'
											editor={(options) => (
												<FileUploadEditor
													addEndpoint='/Memo/AddMemoDocuments'
													deleteEndpoint='/Memo/DeleteMemoDocuments'
													idName='MemoId'
													options={options}
												/>
											)}
											body={(rowData) => (
												<ul className='list-style-none'>
													{rowData.memoDocuments &&
														rowData.memoDocuments.map((p, i) => (
															<li key={i}>
																<a
																	download={p.fileName}
																	href={`data:${p.documentType};base64,${p.data}`}
																	className='text-primary text-underlined cursor-pointer mr-2'
																>
																	{p?.fileName}
																</a>
															</li>
														))}
												</ul>
											)}
										/>
										{
											getPermission('Memo.update') && <Column headerClassName='text-bold bg-primary text-default' style={{ width: '2.5rem' }} rowEditor body={(row) => <Icons.edit
												size={20}
												className='text-primary cursor-pointer'
												onClick={() => {
													setAddMemoModal({
														open: true, edit: true, data: {
															id: row?.id,
															projectId: row?.projectId,
															reviewDate: row?.reviewDate,
															reminderDate: null,
															note: row?.note,
															files: row?.memoDocuments
														}
													})
												}} />} />
										}
										{
											getPermission('Memo.delete') && <Column
												headerClassName='text-bold bg-primary text-default'
												field='action'
												style={{ width: '2.5rem' }}
												className='text-semi-bold pl-0'
												body={(rowData) => (
													<span className='d-flex gap-3'>
														{deleteButton(rowData, '/Memo/DeleteMemos', 'memos')}
													</span>
												)}
											/>
										}
									</DataTable>
									<DataTable
										className='mt-5'
										emptyMessage='Hiç Kayıt Bulunamadı'
										size="small"
										responsiveLayout="stack"
										onRowEditInit={e => dispatch(setEdittedRow(e.data))}
										editMode='row'
										dataKey='id'
										header={
											<TableHeader
												title='Proje Dökümanları'
												button={isAddDocument && <Button className='btn-primary btn-sm' handleClick={() => setDocumentModal(true)} title='Doküman Ekle' icon={<Icons.plus />} />}
											/>
										}
										value={projectDocument}
									>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold'
											style={{ width: '30%' }}
											field='fileName'
											header='Dosya Adı'
											sortable='true'
											body={(rowData) => (
												rowData &&
												<div className='d-flex gap-2 align-items-center'>
													{rowData.fileName}
													<Icons.download className='text-success cursor-pointer' onClick={() => downloadFile(rowData, '/Project/GetDocumentById')} size={16} />
												</div>
											)}
										/>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold'
											//style={{ width: 'auto' }}
											field='createdBy'
											header='Dokümanı Ekleyen Kişi'
											sortable='true'
										/>
										{/* buradaki degerleri update et */}
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold'
											style={{ width: 'auto' }}
											field='continuousReportType'
											header='Rapor Tipi'
											sortable='true'
											body={(rowData) => {

												return <span>{rowData?.continuousReportType == "AYLIKSTATU" ? "AYLIK STATÜ RAPORLARI" : rowData?.continuousReportType == "HAFTALIKSTATU" ? "HAFTALIK STATÜ RAPORLARI" : rowData?.continuousReportType == "ANALIZDOKUMANI" ? "ANALİZ DÖKÜMANI" : rowData?.continuousReportType == "EGITIMDOKUMANI" ? "EĞİTİM DÖKÜMANI" : rowData?.continuousReportType == "PROJEPLANI" ? "Proje Planı" : rowData?.continuousReportType == "PROJEKUNYESI" ? "Proje Künyesi" : "DİĞER"}</span>
											}}
										/>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold vertical-align-top'
											field='createdAt'
											header='Eklenme Tarihi'
											sortable='true'
											style={{ width: 'auto' }}
											body={(rowData) => {
												const createdAt = rowData.createdAt && moment(rowData.createdAt).format('LL')
												return <span>{createdAt}</span>
											}}
										/>
										<Column
											headerClassName='text-bold bg-primary text-default'
											className='text-semi-bold vertical-align-top'
											field='documentDate'
											header='Rapor Tarihi'
											sortable='true'
											style={{ width: 'auto' }}
											body={(rowData) => {
												const documentDate = rowData.documentDate && moment(rowData.documentDate).format('LL')
												return <span>{documentDate}</span>
											}}
										/>
										{
											getPermission('ProjectDocument.delete') && <Column
												headerClassName='text-bold bg-primary text-default'
												field='action'
												style={{ width: '2.5rem' }}
												className='text-semi-bold pl-0'
												body={(rowData) => (
													<span className='d-flex gap-3'>
														{deleteButton(rowData, '/Project/DeleteProjectDocuments', 'projectDocuments')}
													</span>
												)}
											/>
										}

									</DataTable>
								</div>
							</div>
						</div>
					</AccordionComp>
				</div>
			</div>
			<Dialog draggable={false} visible={invoiceInlineApprovalModal.open} onHide={handleCloseInlineApprovalModal}>
				<InvoiceInlineApprovalModalContent handleClose={handleCloseInlineApprovalModal} approvalModal={invoiceInlineApprovalModal} />
			</Dialog>
			<Dialog style={{ width: widthRate }} header={widthRate == '80vw' ? project.name + ' Projesi Rate Listesi' : 'Rate Ekle'} visible={dialog} onHide={setDialog} draggable={false}>
				<Rate setCurrentRate={setCurrentRate} checkBetween={checkBetween} setWidth={setRateFunc} />
			</Dialog>
			<Dialog style={{ width: widthTeam }} header={widthTeam == '80vw' ? project.name + ' Projesi Ekip Listesi' : 'Ekip Üyesi Ekle'} visible={teamDialog} onHide={setTeamDialog} draggable={false}>
				<Team fetchProjectDetail={fetchProjectDetail} setWidth={setTeamFunc} />
			</Dialog>
			<Dialog header='Yeni Fatura Adımı Ekle' visible={iyzicoDialog} onHide={setIyzicoDialog} draggable={false}>
				<IyzicoBill onHide={setIyzicoDialog} />
			</Dialog>
			<Dialog header='Fatura Bilgileri' visible={editInvoiceModal.open} onHide={() => setEditInvoiceModal({ open: false, formData: {}, isEditable: false })} draggable={false}>
				<EditInvoiceModalContent editInvoiceModal={editInvoiceModal} onHide={() => setEditInvoiceModal({ open: false, formData: {}, isEditable: false })} />
			</Dialog>
			<Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
				<ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} />
			</Dialog>
			<Dialog draggable={false} visible={approval.open} onHide={handleCloseApproval}>
				<ApprovalModalContent handleClose={handleCloseApproval} handleApproved={handleSubmitApproved} approvalModal={approval} />
			</Dialog>
			<Dialog draggable={false} header='SLA Ekle' visible={addSlaModal} onHide={setAddSlaModal}>
				<SlaModalContent handleClose={() => setAddSlaModal(false)} handleAdd={handleSlaOpen} />
			</Dialog>
			<Dialog draggable={false} header={slaInvoicesModal.step == 2 ? 'Fatura Ekle' : slaInvoicesModal.header} visible={slaInvoicesModal.open} onHide={() => setSlaInvoicesModal({ open: false, slaId: null, step: 1, isClosed: true })}>
				<SlaInvoicesModalContent modalOpen={slaInvoicesModal} setModalOpen={setSlaInvoicesModal} />
			</Dialog>
			<Dialog draggable={false} header='Ek Geliştirme Ekle' visible={addCrModal} onHide={setAddCrModal}>
				<AddCrModalContent currentRate={currentRate?.budget} handleClose={() => setAddCrModal(false)} handleAdd={handleCrOpen} />
			</Dialog>
			<Dialog draggable={false} header={crInvoicesModal.step == 2 ? 'Fatura Ekle' : crInvoicesModal.header} visible={crInvoicesModal.open} onHide={() => setCrInvoicesModal({ open: false, slaId: null, step: 1, isClosed: true })}>
				<CrInvoicesModalContent modalOpen={crInvoicesModal} setModalOpen={setCrInvoicesModal} />
			</Dialog>
			<Dialog className='reviewRecord' draggable={false} header='Review Kaydı Ekle' visible={addMemoModal?.open} onHide={() => { setAddMemoModal({ open: false, edit: false, data: {} }) }}>
				<AddMemoModalContent addMemoModal={addMemoModal} handleClose={() => setAddMemoModal({ open: false, edit: false, data: {} })} handleAdd={handleMemoOpen} />
			</Dialog>
			<Dialog draggable={false} header='Doküman Ekle' visible={documentModal} onHide={setDocumentModal}>
				<AddDocumentModalContent handleClose={() => setDocumentModal(false)} handleAdd={handleDocumentOpen} />
			</Dialog>
			<Dialog draggable={false} header='Personel Ekle / Düzenle' visible={addOutsourceModal.open} onHide={() => setAddOutsourceModal({open: false, id: null})}>
				<AddOutsourceModalContent handleClose={() => setAddOutsourceModal({open: false, id: null})} handleAdd={handleOutsourceOpen} outsourceId={addOutsourceModal.id} />
			</Dialog>
			<Dialog style={{ width: '1000px' }} draggable={false} header={addOutsourceInvoiceModal.id ? 'Fatura Personel Detayı' : 'Fatura Ekle'} visible={addOutsourceInvoiceModal.open} onHide={() => setAddOutsourceInvoiceModal({open: false, id: null})}>
				<AddOutsourceInvoiceModalContent handleClose={() => setAddOutsourceInvoiceModal({open: false, id: null})} handleAdd={handleOutsourceInvoicesOpen} invoiceId={addOutsourceInvoiceModal.id} />
			</Dialog>
			<Dialog draggable={false} header='Kiralama Ekle / Düzenle' visible={upsertLeasingModal.open} onHide={() => setUpsertLeasingModal({open: false, id: null})}>
				<AddLeasingModalContent handleClose={() => setUpsertLeasingModal({open: false, id: null})} handleAdd={handleLeasingOpen} leasingId={upsertLeasingModal.id} />
			</Dialog>
			<Dialog draggable={false} header={leasingInvoicesModal.step == 2 ? 'Fatura Ekle' : leasingInvoicesModal.header} visible={leasingInvoicesModal.open} onHide={() => setLeasingInvoicesModal({ open: false, leasingId: null, step: 1, isClosed: true })}>
				<LeasingInvoicesModalContent modalOpen={leasingInvoicesModal} setModalOpen={setLeasingInvoicesModal} />
			</Dialog>
		</AnimatedSpan>
	)
}

export default ProjectDetail
